"use client";
import { motion, useScroll, useTransform } from "framer-motion";
import Image from "next/image";
import { useRef } from "react";
import { BannerCard } from "../Card/BannerCard";
import FlipText from "./FlipText";
import { TypewriterEffect } from "./TypewriterEffect";

export default function TextParallax() {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start start", "end start"],
  });

  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.85]);
  const opacity = useTransform(scrollYProgress, [0, 1], [1, 0]);

  const targetRefOverlay = useRef(null);
  const { scrollYProgress: scrollYProgressOverlay } = useScroll({
    target: targetRefOverlay,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgressOverlay, [0, 1], [250, -250]);
  const opacityOverlay = useTransform(
    scrollYProgressOverlay,
    [0.25, 0.5, 0.75],
    [0, 1, 0]
  );
  const fadeInStart = { opacity: 0 };
  const fadeInEnd = { opacity: 1 };

  return (
    <div className="h-screen w-full">
      <motion.div
        style={{
          width: "100%",
          backgroundPosition: "center",
          top: 0,
          scale,
        }}
        ref={targetRef}
        className="sticky h-screen z-0 overflow-hidden rounded-b-xl"
      >
        <motion.div
          initial={fadeInStart}
          animate={fadeInEnd}
          transition={{ duration: 1 }}
          className="relative w-full h-full"
        >
          <Image
            alt="Banner Light"
            src={"/images/banner-light.jpg"}
            width={0}
            height={0}
            priority
            quality={100}
            sizes="100vw"
            className="w-full h-full object-cover block dark:hidden"
          />
          <Image
            alt="Banner Dark"
            src={"/images/banner-dark.jpg"}
            width={0}
            priority
            quality={100}
            height={0}
            sizes="100vw"
            className="w-full h-full object-cover hidden dark:block"
          />
        </motion.div>
        <motion.div
          className="absolute inset-0 bg-neutral-950/30"
          style={{
            opacity,
          }}
          initial={fadeInStart}
          animate={fadeInEnd}
          transition={{ duration: 1 }}
        />
      </motion.div>
      <motion.div
        style={{
          y,
          opacity: opacityOverlay,
        }}
        ref={targetRefOverlay}
        className="absolute left-0 top-0 flex h-screen w-full flex-col items-center mt-16 text-white text-5xl font-extrabold uppercase sm:text-6xl md:text-7xl lg:text-8xl"
      >
        <motion.div
          initial={fadeInStart}
          animate={fadeInEnd}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="text-base normal-case font-normal w-auto bg-[#00000069] rounded-xl px-4 mb-4 mt-16"
        >
          <TypewriterEffect
            words={[
              {
                text: "Website",
              },
              {
                text: "tạo",
              },
              {
                text: "bởi",
              },
              {
                text: "Hồ Văn Đoan",
                className: "text-[#509eff] dark:text-primary",
              },
            ]}
            className="text-[#ffffff]"
            cursorClassName="bg-[#509eff] dark:bg-white w-auto"
          />
        </motion.div>
        <motion.div
          initial={fadeInStart}
          animate={fadeInEnd}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="flex flex-col w-full items-center justify-center lg:flex-row gap-4 md:gap-4 lg:gap-8 transition-all duration-[0.3s]"
        >
          <FlipText>Web</FlipText>
          <FlipText>DEVELOPER</FlipText>
        </motion.div>
        <motion.div
          initial={fadeInStart}
          animate={fadeInEnd}
          transition={{ duration: 0.7, delay: 1 }}
          className="flex flex-col w-full items-center justify-center lg:flex-row gap-4 md:gap-4 lg:gap-8 mt-4 transition-all duration-[0.3s]"
        >
          <FlipText>Ho Van Doan</FlipText>
          <FlipText>IT</FlipText>
        </motion.div>
        <BannerCard />
      </motion.div>
    </div>
  );
}
